module.exports = __webpack_public_path__ + "img/list_Story_15.d98a598b.jpeg";